import { useParams } from "react-router-dom";
import ConundrumDisplayRenderer from "src/pods/conundrums/components/ConundrumDisplayRenderer";

type ConundrumDisplayRendererParams = {
  conundrumName: string;
  stepName: string;
};

export default function ConundrumStep() {
  const { conundrumName = "", stepName = "" } = useParams<ConundrumDisplayRendererParams>();

  return <ConundrumDisplayRenderer params={{ conundrumName, stepName }} />;
}
